// Utility function to move to the next slide
import React from 'react';

export const nextSlide = (
  currentIndex: number,
  itemsLength: number,
  setCurrentIndex: (index: number) => void,
  setExpanded: (expanded: boolean) => void,
  setImageFadeEffect: (effect: string) => void,
  setFadeEffect: (effect: string) => void,
): void => {
  setFadeEffect('opacity-hidden');
  setImageFadeEffect('opacity-hidden');
  setTimeout(() => {
    setCurrentIndex((currentIndex + 1) % itemsLength);
    setExpanded(false);
    setFadeEffect('opacity-visible');
    setImageFadeEffect('opacity-visible');
  }, 500);
};

export const prevSlide = (
  currentIndex: number,
  itemsLength: number,
  setCurrentIndex: (index: number) => void,
  setExpanded: (expanded: boolean) => void,
  setImageFadeEffect: (effect: string) => void,
  setFadeEffect: (effect: string) => void,
): void => {
  setFadeEffect('opacity-hidden');
  setImageFadeEffect('opacity-hidden');
  setTimeout(() => {
    setCurrentIndex((currentIndex - 1 + itemsLength) % itemsLength);
    setExpanded(false);
    setFadeEffect('opacity-visible');
    setImageFadeEffect('opacity-visible');
  }, 500);
};

export const goToSlide = (
  index: number,
  setCurrentIndex: (index: number) => void,
  setExpanded: (expanded: boolean) => void,
  setImageFadeEffect: (effect: string) => void,
  setFadeEffect: (effect: string) => void,
): void => {
  setFadeEffect('opacity-hidden');
  setImageFadeEffect('opacity-hidden');
  setTimeout(() => {
    setCurrentIndex(index);
    setExpanded(false);
    setFadeEffect('opacity-visible');
    setImageFadeEffect('opacity-visible');
  }, 500);
};

export const toggleReadMore = (
  setFadeEffect: (effect: string) => void,
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>,
  isMobileView: boolean,
  setImageFadeEffect: (effect: string) => void,
): void => {
  setFadeEffect('opacity-hidden');
  if (isMobileView) {
    setImageFadeEffect('opacity-hidden');
  }

  setTimeout(() => {
    setExpanded((prevState) => !prevState);

    if (isMobileView) {
      setImageFadeEffect('opacity-hidden');
    }

    setTimeout(() => {
      setFadeEffect('opacity-visible');
      if (isMobileView) {
        setImageFadeEffect('opacity-visible');
      }
    }, 50);
  }, 500);
};

export const updateView = (
  setIsMobileView: (isMobileView: boolean) => void,
): void => {
  setIsMobileView(window.matchMedia('(max-width: 768px)').matches);
};
